<template>
  <el-drawer
    title="登录日志"
    :visible.sync="drawer"
    :modal-append-to-body="false"
    append-to-body
    destroy-on-close
    :wrapperClosable="false"
    :custom-class="sidebarIsOpen ? 'width210' : 'width54'"
  >
    <el-card>
      <el-table v-loading="loading" ref="multipleTable" row-key="id" :data="tableData" tooltip-effect="light" :header-cell-style="{ backgroundColor: '#ffffff', color: '#000' }">
        <el-table-column label="登录终端" align="center">
          <template slot-scope="scope">{{ scope.row.terminalStr || '-' }}</template>
        </el-table-column>
        <el-table-column label="登录状态" align="center">
          <template slot-scope="scope">
            <span v-if="!scope.row.result">-</span>
            <span v-else>{{ scope.row.result === 1 ? '成功' : '失败' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作详情" align="center">
          <template slot-scope="scope">{{ scope.row.operationName || '-' }}</template>
        </el-table-column>
        <el-table-column label="登录地址" align="center">
          <template slot-scope="scope">{{ scope.row.requestIp || '-' }}</template>
        </el-table-column>
        <el-table-column label="登录时间" align="center" width="180">
          <template slot-scope="scope">
            {{ scope.row.createTime || '-' }}
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        layout="total, prev, pager, next, jumper,sizes"
        :current-page.sync="page.pageNo"
        :page-size.sync="page.pageSize"
        :page-sizes="[10, 50, 100]"
        :total="total"
        @size-change="currentChange"
        @current-change="currentChange"
      />
    </el-card>
  </el-drawer>
</template>

<script>
import { loginOperationLogCount, loginOperationLogPage } from '@/api/user'
export default {
  data() {
    return {
      drawer: false,
      tableData: [],
      page: {
        pageNo: 1,
        pageSize: 10,
      },
      total: 0,
      loading: false,
    }
  },
  watch: {
    drawer(val) {
      if (val) this.getList()
    },
  },
  methods: {
    async getList() {
      this.loading = true
      loginOperationLogPage({ ...this.page })
        .then(({ data }) => {
          this.tableData = data || []
        })
        .finally(() => {
          this.loading = false
        })
      const { data: total } = await loginOperationLogCount({ ...this.page })
      this.total = parseInt(total || 0)
    },
    currentChange() {
      this.getList()
    },
  },
}
</script>

<style lang="scss" scoped></style>
